module.exports = __webpack_public_path__ + "static/media/Flautas ahogadas callejeras.0a80f850.webp";